import "./PromptCreative.scss";

import * as React from "react";
import PropTypes from "prop-types";
import { Button, ButtonToolbar } from "react-bootstrap";

import TrackingUtil from "../../utils/TrackingUtil";
import { CreativeElement, CreativeButton } from "../../datatypes/Creatives";
import { TrackingTags } from "../../datatypes/Tracking";

type Props = {
    creative: Array<CreativeElement>;
    onClick?: () => void;
    onDismiss?: () => void;
};

class PromptCreative extends React.Component<Props> {
    static contextTypes = {
        router: PropTypes.object.isRequired
    };

    renderButton(b: CreativeButton): React.ReactNode {
        const clickHandler = (evt: React.SyntheticEvent<any>) => {
            if (b.trackingName) {
                const tags: TrackingTags = { name: b.trackingName };
                TrackingUtil.trackStructuredEvent("creative.button", { tags: tags });
            }
            if (this.props.onClick) {
                this.props.onClick();
                evt.stopPropagation();
            }
            if (b.target) {
                switch (b.target.type) {
                    case "REL_LINK":
                        this.context.router.push(b.target.data);
                        break;
                    case "PURE_LINK":
                        window.location.assign(b.target.data);
                        break;
                    default:
                        break;
                }
            }
        };
        return <Button onClick={clickHandler}>{b.text}</Button>;
    }

    renderNode(c: CreativeElement): React.ReactNode {
        const renderMap = {
            h1: (c: CreativeElement) => <h1>{c.text}</h1>,
            text: (c: CreativeElement) => <p>{c.text}</p>,
            footnote: (c: CreativeElement) => (
                <p className="text-muted">
                    <small>{c.text}</small>
                </p>
            ),
            MAC: (c: CreativeElement) => <img src={c.imageUrl} className="img-responsive" />,
            buttonRow: (c: CreativeElement) => (
                <ButtonToolbar>{c.buttons && c.buttons.map(b => this.renderButton(b))}</ButtonToolbar>
            )
        };

        if (c && c.type && renderMap[c.type]) {
            try {
                return renderMap[c.type](c);
            } catch (error) {
                TrackingUtil.trackUIError("PromptCreative", "Could not render " + c.type, error);
            }
        }
        return null;
    }

    handleClick = () => {
        if (this.props.onDismiss) {
            this.props.onDismiss();
        }
    };

    render() {
        return (
            <div onClick={this.handleClick} className="ex-creative-content test-creative-content">
                {this.props.creative.map(c => this.renderNode(c))}
            </div>
        );
    }
}

export default PromptCreative;
